import React, { useState } from "react";
import { useQuery, useMutation, gql } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import Header from "../../../components/common/header";
import { GET_SELLER_STORE } from "../api/seller-store";
import { notify } from "../../../utils/toast";
import LoadingSpinnerFull from "../../../components/common/loading-spinner/loading-spinner-full";

const UPDATE_LIVE_ORDER_NOTICE = gql`
  mutation UpdateLiveOrderNotice($liveOrderNotice: String!) {
    updateLiveOrderNotice(liveOrderNotice: $liveOrderNotice) {
      id
      liveOrderNotice
    }
  }
`;

const LiveOrderNoticeManagement: React.FC = () => {
  const navigate = useNavigate();
  const { data: storeData, loading } = useQuery(GET_SELLER_STORE, {
    fetchPolicy: "cache-and-network",
  });
  const [updateLiveOrderNotice] = useMutation(UPDATE_LIVE_ORDER_NOTICE);
  const [notice, setNotice] = useState("");

  React.useEffect(() => {
    if (storeData?.getSellerStore?.liveOrderNotice) {
      setNotice(storeData.getSellerStore.liveOrderNotice);
    }
  }, [storeData]);

  const handleSave = async () => {
    try {
      await updateLiveOrderNotice({
        variables: {
          liveOrderNotice: notice,
        },
      });
      notify("공지사항이 저장되었습니다.");
      navigate("/boss/home");
    } catch (error) {
      console.error("Error updating notice:", error);
      notify("오류가 발생했습니다.");
    }
  };

  if (loading) return <LoadingSpinnerFull />;

  return (
    <div className="bg-gray-50 min-h-screen">
      <Header title="실시간 판매 공지 수정" showBackButton />
      <div className="p-6">
        <div className="max-w-xl mx-auto bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-bold mb-4">
            📢 구매 전 알림(특이사항){" "}
            <span className="text-gray-500 text-lg font-normal">(선택)</span>
          </h2>

          <div className="mb-4">
            <p className="text-sm text-gray-600 mb-2">
              고객이 상품을 구매하기 전에 볼 수 있는 공지사항을 작성해주세요.
              <br />
              (예: 매장 참고사항, 픽업 방법 안내, 알러지 정보 등)
            </p>
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 font-semibold mb-2">
              공지 내용
            </label>
            <textarea
              value={notice}
              onChange={(e) => setNotice(e.target.value)}
              placeholder="공지 내용을 입력해주세요"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-400 transition duration-200 break-keep"
              rows={6}
            />
          </div>

          <div className="flex justify-end gap-2 mt-6">
            <button
              onClick={() => navigate("/boss/home")}
              className="px-4 py-2 bg-gray-400 text-white rounded-lg active:bg-gray-500 transition duration-200"
            >
              취소
            </button>
            <button
              onClick={handleSave}
              className="px-4 py-2 bg-blue-500 text-white rounded-lg active:bg-blue-600 transition duration-200"
            >
              저장
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LiveOrderNoticeManagement;
